export const caption = {
    login: 'Votre compte secondaire : ',
    serviceHelp: 'Vous pouvez le communiquer à l\'utilisateur de ce compte secondaire.',
}

export const button = {
    login: 'Retour à la liste des comptes',
}
